<div class="loading-overlay" *ngIf="isLoading">
  <mat-progress-spinner
    mode="indeterminate"
    color="primary"
  ></mat-progress-spinner>
</div>

<div class="warn-dialog">
  <div class="title">
    <p>Selecionar pessoas</p>
    <mat-icon style="cursor: pointer; color: #5f6368" (click)="onCancel()"
      >close</mat-icon
    >
  </div>

  <hr />

  <div class="aviso-container">
    <div class="icone-aviso">
      <img alt="aviso" src="../../../../../assets/svg/icons/warning.svg" />
    </div>

    <div class="texto-aviso">
      <p class="titulo-aviso">Algumas pessoas não podem ser desmarcadas</p>
      <p class="conteudo-aviso">
        Essas pessoas pertencem ao grupo ou empresas selecionados e, por isso,
        não podem ser desmarcadas individualmente. Para removê-las, é necessário
        excluir o grupo ou a empresa deste disparo de aviso.
      </p>
    </div>
  </div>

  <div class="content">
    <div class="container-filtros">
      <div class="filtro-container">
        <mat-form-field appearance="outline" class="filtro">
          <mat-label>Filtrar por empresa</mat-label>
          <mat-select
            multiple
            [(value)]="empresasSelecionadas"
            (selectionChange)="filtrarPorEmpresa()"
          >
            <mat-select-trigger>
              {{
                empresasSelecionadas.length > 0
                  ? empresasSelecionadas.length + " selecionadas"
                  : "Todas"
              }}
            </mat-select-trigger>
            <mat-option
              *ngFor="let empresa of listaEmpresas"
              [value]="empresa.id"
            >
              <mat-checkbox
                [checked]="empresasSelecionadas.includes(empresa.id)"
              >
                {{ empresa.nomeFantasia }}
              </mat-checkbox>
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <mat-form-field appearance="outline" class="search-field">
        <mat-label>Buscar por nome e número do documento</mat-label>
        <img
          matPrefix
          src="../../../../../assets/svg/icons/search.svg"
          alt="Lupa"
          class="search-icon"
        />
        <input
          matInput
          type="text"
          placeholder=" "
          (input)="updateFieldText($event)"
        />
      </mat-form-field>
    </div>

    <table mat-table [dataSource]="pessoas" class="cis-default-table" matSort>
      <ng-container matColumnDef="selecionar">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let pessoa">
          <mat-checkbox
            [checked]="pessoaSelecionada(pessoa)"
            [disabled]="pessoaBloqueada(pessoa)"
            (change)="alternarPessoaSelecionada(pessoa, $event.checked)"
          >
          </mat-checkbox>
        </td>
      </ng-container>

      <ng-container
        *ngFor="let coluna of colunasTabela"
        [matColumnDef]="coluna.id"
      >
        <th
          mat-header-cell
          class="header"
          *matHeaderCellDef
          mat-sort-header
          disableClear
        >
          {{ coluna.header }}
        </th>
        <td mat-cell *matCellDef="let pessoa">
          <ng-container [ngSwitch]="coluna.propriedade">
            <span>
              {{ pessoa[coluna.propriedade] }}
            </span>
          </ng-container>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr
        mat-row
        *matRowDef="let row; columns: displayedColumns"
        [class.bloqueada]="pessoaBloqueada(row)"
      ></tr>
    </table>
  </div>

  <hr />

  <div class="modal-footer" mat-dialog-actions>
    <button matButton="filled" (click)="onConfirm()">
      Confirmar e selecionar
    </button>
  </div>
</div>
